export enum UserDocumentType {
  ContractArchive = 'CONTRACT_ARCHIVE',
  OfwcaAuthorization = 'OFWCA_AUTHORIZATION',
  OfwcaExamCP = 'OFWCA_EXAM_CP',
  OfwcaExamCard = 'OFWCA_EXAM_CARD',
  OfwcaKrkDeclaration = 'OFWCA_KRK_DECLARATION',
  OfwcaKrkForm = 'OFWCA_KRK_FORM',
  OfwcaKrkScan = 'OFWCA_KRK_SCAN',
  OfwcaKrkScanXML = 'OFWCA_KRK_SCAN_XML',
  OfwcaKrkScanXades = 'OFWCA_KRK_SCAN_XADES'
}
